import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material'
import { useMutation, useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { deleteFaqFn, getFaqFn } from 'Services/FAQ'

const FAQ = () => {
    const navigate = useNavigate();
    const { data: faqResponse, refetch } = useQuery({
        queryFn: getFaqFn,
        queryKey: ['get-faq']
    })

    const { mutate: deleteBlog } = useMutation(deleteFaqFn, {
        onSuccess: (response) => {
            toast.success("Deleted Successfully");
            refetch();
        }
    });

    const deleteHandle = (id) => {
        const formData = new FormData();
        formData.append("faq_id", id);
        deleteBlog(formData);
    };

    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-4">
                <Typography variant="h5" component="h2" className='!text-black font-bold'>
                    FAQ
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate(`/faq/add`)}
                >
                    Add
                </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {faqResponse?.data?.data?.map((item) => (
                    <Card key={item.id} className="bg-white shadow-lg rounded-lg">
                        <CardContent>
                            <Typography
                                variant="h6"
                                component="div"
                                className="mb-2 line-clamp-2"
                            >
                                {item.question}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                className="line-clamp-3"
                                dangerouslySetInnerHTML={{ __html: item?.answer }}
                            />
                        </CardContent>
                        <CardActions>
                            <Button
                                size="small"
                                color="primary"
                                onClick={() => navigate(`/faq/update/${item?.id}`)}
                            >
                                <EditIcon />
                                Update
                            </Button>
                            <Button
                                size="small"
                                color="error"
                                onClick={() => deleteHandle(item.id)}
                            >
                                <DeleteIcon />
                                Delete
                            </Button>
                        </CardActions>
                    </Card>
                ))}
            </div>
        </div>
    )
}

export default FAQ